import type { MouseEvent } from 'react';

import type { ProductEvent } from '../../../enums/Tracking';
import { dispatchTrackingEventGA4 } from '../../../tracking/dispatchTrackingEventGA4';
import type { DrawerInteraction, Element } from '../../../types/tracking';
import type { TrackingContext } from '../types/types';

interface SwatchesClickEventOptions {
  sku: string;
  type: string;
  eventName: ProductEvent;
  element: Element;
  interaction: DrawerInteraction;
}

export const dispatchSwatchesClickEvent = ({
  sku,
  type,
  eventName,
  element,
  interaction,
}: SwatchesClickEventOptions) => {
  dispatchTrackingEventGA4({
    event: eventName,
    element,
    interaction,
    sku_parent: sku,
    label_name: type,
  });
};

export const getClickTrackingHandler =
  (sku: string, { eventName, element, interaction }: TrackingContext) =>
  ({ target }: MouseEvent) => {
    if (!(target instanceof HTMLElement)) return;
    const type = target.dataset.type ?? target.parentElement?.dataset.type;
    dispatchSwatchesClickEvent({ sku, type: type ?? 'container', eventName, element, interaction });
  };
